export const SEARCH_RESULTS = "SEARCH_RESULTS";
export const USER_LOGIN = "USER_LOGIN";
export const USER_REGISTER = "USER_REGISTER";
export const FILTER_INACTIVE_USERS = "FILTER_INACTIVE_USERS";
export const GET_REVIEWS = "GET_REVIEWS";
export const GET_SEARCH_DATA = "GET_SEARCH_DATA";
export const GET_SEARCH_CATEGORY = "GET_SEARCH_CATEGORY";
//Company
export const GET_ALL_COMPANIES = "GET_ALL_COMPANIES";
export const GET_TERMINAL = "GET_TERMINAL";
export const GET_ALL_RUTES = "GET_ALL_RUTES";
export const DELETE_RUTE = "DELETE_RUTE";
export const GET_PRODUCTOS = 'GET_PRODUCTOS';
export const GET_ALL_USERS = 'GET_ALL_USERS';
export const DELETE_USER = 'DELETE_USER';
export const CREATED_ROUTE = 'CREATED_ROUTE';
export const GET_ALL_PRODUCTS = 'GET_ALL_PRODUCTS';
export const GET_ALL_CATEGORIES = 'GET_ALL_CATEGORIES';
export const GET_FACTURAS_MAP = "GET_FACTURAS_MAP";
export const GET_ALL_FACTURAS = "GET_ALL_FACTURAS";